export default "__VITE_ASSET__vNq6N86T__"